import { borderRadius, margin, scaleW } from '@/common/style';
import React, { useEffect, useRef } from 'react';
import { Animated, View, ViewStyle } from 'react-native';

const Styles = {
    container: {},
    line: {
        height: 24,
        marginBottom: 6,
    },
    ske: {
        backgroundColor: '#f2f2f2',
        opacity: 0.6,
    },
} as { [key: string]: ViewStyle };

export function SpecLinePopSke() {
    const opacityAnim = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        Animated.loop(
            Animated.sequence([
                Animated.timing(opacityAnim, {
                    toValue: 1,
                    duration: 600,
                    useNativeDriver: true,
                }),
                Animated.timing(opacityAnim, {
                    toValue: 0.6,
                    duration: 600,
                    useNativeDriver: true,
                }),
            ]),
        ).start();
    }, [opacityAnim]);

    const mapLine = (num: number) =>
        Array.from({ length: num }).map((_, index) => <Animated.View key={index} style={[Styles.line, Styles.ske, { opacity: opacityAnim }]} />);

    const skeView = (style) => <Animated.View style={[Styles.line, Styles.ske, { opacity: opacityAnim }, style]} />;

    return (
        <View
            style={{
                width: '100%',
                height: '100%',
            }}
        >
            <View
                style={{
                    flexDirection: 'row',
                    marginBottom: scaleW(12),
                }}
            >
                <View>
                    {skeView({
                        height: scaleW(120),
                        width: scaleW(120),
                        borderRadius: scaleW(6),
                        marginRight: scaleW(16),
                    })}
                </View>
                <View style={{ flex: 1, justifyContent: 'space-between' }}>
                    {skeView({
                        height: scaleW(30),
                        width: scaleW(80),
                        borderRadius: scaleW(6),
                    })}
                    <View>
                        {skeView({
                            height: scaleW(30),
                            width: scaleW(120),
                            borderRadius: scaleW(6),
                        })}
                        {skeView({
                            height: scaleW(30),
                            width: scaleW(180),
                            borderRadius: scaleW(6),
                        })}
                    </View>
                </View>
            </View>
            <View style={{ height: 120, justifyContent: 'space-between', marginBottom: scaleW(20) }}>
                {skeView({
                    height: scaleW(30),
                    width: scaleW(80),
                    borderRadius: scaleW(6),
                })}
                <View>
                    {skeView({
                        height: scaleW(30),
                        borderRadius: scaleW(6),
                    })}
                    {skeView({
                        height: scaleW(30),
                        borderRadius: scaleW(6),
                    })}
                </View>
            </View>

            <View style={{ height: 120, justifyContent: 'space-between' }}>
                {skeView({
                    height: scaleW(30),
                    width: scaleW(80),
                    borderRadius: scaleW(6),
                })}
                <View>
                    {skeView({
                        height: scaleW(30),
                        borderRadius: scaleW(6),
                    })}
                    {skeView({
                        height: scaleW(30),
                        borderRadius: scaleW(6),
                    })}
                </View>
            </View>
            <View style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                {skeView({
                    height: scaleW(50),
                    borderRadius: scaleW(6),
                })}
            </View>
        </View>
    );
}
